import Module, { ViewLayer, moduleInit, bindButtonClickEvent } from "../../../../../framework/core/mvvm/module_base";
import { InsideTaskView } from "./inside_task_view";
import { TaskHelp } from "../task_help";
import ModuleManager from "../../../../../framework/core/module_manager";
import { TaskDataCache } from "../task_data";
import Utility from "../../../../../utility/utility";

const {ccclass, property} = cc._decorator;

@ccclass
@moduleInit('InsideTaskModule')
export  class InsideTaskModule extends Module<InsideTaskView,null> {
    constructor(){
        super();
        this.layer = ViewLayer.Mid;
        this.windowPrefabResPath = "package/hall/module/gametask/insidetask";
        this.viewType = InsideTaskView
        this.modelType = null
        //this.needAnim = true
        //this.needViewMask = true
        this.clickAnywhereClose = false;
    }

    maxItemCnt:number = 4;

    onInit(){
        this.eventBind('_taskItem_Refresh_',this.refreshItem);
    }

    onShow(arg){
        //更新动画状态
        this.view.setAnimName(0);
        this.showBtnPos(arg);
        this.view.initView(this.clickItemFunc.bind(this));
        this.view.isShowPanel(false,false)
        this.reqTask();
    }

    @bindButtonClickEvent('taskBtn')
    clcikShowTaskBtn(){
        this.view.isShowPanel(true,true)
        this.reqTask();
    }

    reqTask(){
        let self = this;
        TaskDataCache.instance.getTaskData('everyday',(data:any[])=>{
            let useData = data.concat([]);
            if(useData.length > this.maxItemCnt){
                useData.splice(this.maxItemCnt, data.length - this.maxItemCnt)
            }
            self.view.setItemData(useData);
            let isCanReceive = TaskHelp.isCanReceive(useData);
            self.view.setAnimName(isCanReceive ? 0:1)
        },this);
    }

    @bindButtonClickEvent('mask')
    clcikMaskClose(){
        let self = this;
        self.view.isShowPanel(false,true)
    }

    showBtnPos(openModule){
      let curMoude=ModuleManager.instance.getModule(openModule)
      let node = curMoude.getTaskNode();
      if (node) {
            let tempLocaltion = node.convertToWorldSpaceAR(cc.Vec2.ZERO);
            let localPos = this.view.getAnimBtn().parent.convertToNodeSpaceAR(tempLocaltion);
            this.view.setBtnPos(localPos);
      }
    }

    
    //任务领取刷新
    onAwardTask(finish?:Function){
        //领取完成更新
        let self = this;
        TaskDataCache.instance.getTaskData('everyday',(data:any[])=>{
            self.view.setItemData(data);
        },this,true);
    }

    clickItemFunc(data:any){
        Utility.playButtonSound();
        let self = this;
        if (data.isFinish && !data.isReceive) {//可领取
            TaskHelp.taskAward(data.taskRefId,data.taskTypeCode,(awardData:any)=>{
                self.showAwardAnim(awardData);
                //刷新所有item
                self.onAwardTask();
            },this)
        }else{
            if (!data.isFinish) {//去完成
                TaskHelp.goToFinishTask(data.conditionCode);
                this.hide();
            }
        }
    }

    private refreshItem(data:any){
        //更新单条
    }

    private showAwardAnim(data:any){
        this.getSelfCurrencyData(null, true)
        let chipNum = 0
        let goldNum = 0
        if(data){
            if (data.awardAccountType == 5) {
                chipNum += Number(data.awardAccountVal)
            }else if(data.awardAccountType == 6){
                goldNum += Number(data.awardAccountVal)
            }          
            ModuleManager.instance.showModuleName('DialogReceive', {chipNum: chipNum, goldNum: goldNum})
        }
    }

}
